import { AfterViewInit, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { distinctUntilChanged, filter } from 'rxjs/operators';
import { ILogoutRequest } from '../../../../../src/app/features/auth/models/logout.model';
import { ILegalEntitiesBusinessesResponse } from '../../../../../src/app/features/todos/models/businesses.model';
import * as logout from '../../../features/auth/actions/logout.actions';
import * as fromToDoSelectors from '../../../features/todos/selectors';
import * as fromToDoActions from '../../../features/todos/actions';
import { fromGetBusinessDetailsActions, clearGetProofBusinessFicaDocs } from '../../../features/businesses-detail/actions';
import { LegalEntityTypes, RouteURL, SessionStorageIds } from '../../../shared/enums';
import { AdviserLandingService } from '../../../core/services/adviser-landing.service';
import * as legalEntityActions from '../../../features/legal-entities/actions';
import { SharedService } from '../../shared.service';
import { faBullhorn } from '@fortawesome/free-solid-svg-icons';
import * as toDoActions from '../../../features/todos/actions';
import { PubSubService } from '../../pubsub.service';
import { getSavedBusinessId } from '../../../features/legal-entities/selectors/legal-entities-list.selectors';

@Component({
  selector: 'app-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.css']
})
export class SideNavComponent implements OnInit, OnDestroy, AfterViewInit {
  items: any[];
  isNavOpen: boolean = false;
  menu: boolean = false;

  /** William Strike users only get Upload Payroll, whatever other permissions their roles carry. */
  get isPayrollOnlyUser(): boolean {
    return AdviserLandingService.isPayrollOnly();
  }
  @Input() routerPage: string;
  legalEntityName: string = 'LE name';
  leName$: Observable<ILegalEntitiesBusinessesResponse>;
  subscription: Subscription = new Subscription();
  chosenLegalEntity: string;
  checkForRefresh: ILegalEntitiesBusinessesResponse;

  isRegulationVerified: boolean;
  isPaymentMethodAdded: boolean;
  isProductChosen: boolean;
  isStatusVerified: boolean | undefined;
  isShowUserOnboardPage: boolean;
  isDisableManageUsersPage: boolean;
  isShowUserAnalyticsPage: boolean;
  faBullhorn = faBullhorn;

  constructor(
    private store: Store,
    public router: Router,
    public sharedService: SharedService,
    private pubsubService: PubSubService,
    private cdr: ChangeDetectorRef
  ) {
    this.leName$ = this.store.select(fromToDoSelectors.getSelectedLegalEntity);
    this.checkIfRegulationVerified();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  ngOnInit(): void {
    const routerPageElement = document.getElementById(this.routerPage);
    if (routerPageElement) {
      routerPageElement.style.marginLeft = '65px';
      routerPageElement.style.overflowX = 'auto';
      routerPageElement.style.height = '98.4vh';
    }

    this.checkLegalEntityStore();

    // Sync from session storage on initial load/refresh (router NavigationEnd already fired before we subscribed)
    this.refreshChosenLegalEntityFromStorage();

    // Load regulation verification data on initialization if businessId is available
    const businessId = sessionStorage.getItem('businessId');
    if (businessId && businessId !== 'null' && businessId !== null) {
      this.store.dispatch(toDoActions.loadRegulationVerified({ businessId: businessId }));
    }
  }

  ngAfterViewInit(): void {
    // Menu items are now statically defined in HTML with permission directives
  }

  checkLegalEntityStore() {
    let le = sessionStorage.getItem('legalEntity');
    const leStored = le ? (JSON.parse(le) as ILegalEntitiesBusinessesResponse) : null;
    this.subscription.add(
      this.leName$.subscribe(leName => {
        this.checkForRefresh = leName;
        this.chosenLegalEntity = leName === undefined ? leStored?.legalEntityName : leName.legalEntityName;

        // Load regulation verification data when legal entity is available
        const businessId = sessionStorage.getItem('businessId');
        if (businessId && businessId !== 'null' && businessId !== null) {
          this.store.dispatch(toDoActions.loadRegulationVerified({ businessId: businessId }));
        }
        this.cdr.markForCheck();
      })
    );

    // Update side menu display when user selects a new legal entity (e.g. from popup while on dashboard)
    this.subscription.add(
      this.store
        .select(getSavedBusinessId)
        .pipe(
          filter((id): id is string => !!id),
          distinctUntilChanged()
        )
        .subscribe(() => this.refreshChosenLegalEntityFromStorage())
    );

    // Refresh display on navigation (e.g. after selecting entity and navigating to dashboard)
    this.subscription.add(
      this.router.events
        .pipe(filter((ev): ev is NavigationEnd => ev instanceof NavigationEnd))
        .subscribe(() => this.refreshChosenLegalEntityFromStorage())
    );
  }

  private refreshChosenLegalEntityFromStorage(): void {
    const stored = sessionStorage.getItem(SessionStorageIds.LEGAL_ENTITY);
    const legalEntity = stored ? (JSON.parse(stored) as ILegalEntitiesBusinessesResponse) : null;
    if (legalEntity?.legalEntityName) {
      this.chosenLegalEntity = legalEntity.legalEntityName;
      const businessId = legalEntity.legalEntityId ?? sessionStorage.getItem(SessionStorageIds.BUSINESS_ID) ?? '';
      if (businessId && businessId !== 'null') {
        this.store.dispatch(toDoActions.loadRegulationVerified({ businessId }));
      }
    }
    this.cdr.markForCheck();
  }

  activateDrawer() {
    const sidenavElement = document.getElementById('mySidenav');
    const routerPageElement = document.getElementById(this.routerPage);

    if (!this.isNavOpen) {
      this.isNavOpen = true;
      this.store.dispatch(fromToDoActions.loadIsSideNavActive({ isSideNavActive: true }));
      if (sidenavElement) {
        sidenavElement.style.width = '250px';
      }
      if (routerPageElement) {
        routerPageElement.style.marginLeft = '250px';
      }
    } else {
      this.isNavOpen = false;
      this.store.dispatch(fromToDoActions.loadIsSideNavActive({ isSideNavActive: false }));
      if (sidenavElement) {
        sidenavElement.style.width = '65px';
      }
      if (routerPageElement) {
        routerPageElement.style.marginLeft = '65px';
      }
    }
  }


  menuActive(val: any) {
    // When navigating from TO DO screen, keep TO DO menu items visible on the next page
    if (this.router.url === '/todo' || this.router.url.startsWith('/todo?') ||
        this.router.url === '/admin-dashboard' || this.router.url.startsWith('/admin-dashboard?')) {
      sessionStorage.setItem('IsFromToDo', 'true');
    }
    switch (val) {
      case 'Dashboard':
        this.menu = false;
        this.routeToEntityDashboard();
        break;
      case 'User group setup':
        this.menu = false;
        this.routeToEmployeeSetup();
        break;
      case 'Products':
        this.menu = false;
        this.routeToProducts();
        break;
      case 'Payment runs':
        this.menu = false;
        this.routeToPaymentRuns();
        break;
      case 'Legal entities':
        this.menu = false;
        this.routerToLegalEntityHierarchy();
        break;
      case 'Legal entity setup':
        this.menu = false;
        this.routeToLegalEntitySetup();
        break;
      case 'Manage Users':
          this.menu = false;
          this.routeToManageUsers();
          break;
      case 'Admin Users':
        this.menu = false;
        this.routeToManageUsers();
        break;
      case 'Admin Dashboard':
        this.menu = false;
        this.routeToAdminDashboard();
        break;
      case 'Entity Admin Dashboard':
        this.menu = false;
        this.routeToEntityAdminDashboard();
        break;
      case 'ASQ Dashboard':
        this.menu = false;
        this.routeToAsqDashboard();
        break;
      case 'Roles':
        this.menu = false;
        this.routeToRoles();
        break;
      case 'Manage Members':
        this.menu = false;
        this.routeToViewEmployees();
        break;
      case 'Manage Products':
        this.menu = false;
        this.routeToManageProducts();
        break;
      case 'Upload Payroll':
        this.menu = false;
        this.routeToWSPayrollUpload();
        break;
      case 'Investment Solutions':
        this.menu = false;
        this.routeToProductSolution();
        break;
      case 'Broadcast':
        this.menu = false;
        this.routeToBroadcast();
        break;
      case 'Update DMA Account values from Opus':
        this.menu = false;
        this.routeToExcludeDmaAccounts();
        break;

      default:
        this.subMenuEmpty();
        break;
    }
  }


  routeToEmployeeSetup() {
    this.router.navigateByUrl('employee-group-setup');
  }

  routeToProducts() {
    this.router.navigateByUrl(RouteURL.PRODUCTS);
  }

  routerToLegalEntityHierarchy() {
    this.router.navigateByUrl('legal-entities');
  }

  routeToLegalEntitySetup() {
    if (!this.isCurrentRoute('/legal-entity-setup')) {
      this.store.dispatch(fromGetBusinessDetailsActions.clearGetBusinessDetailsResponse());
      this.store.dispatch(clearGetProofBusinessFicaDocs());
    }
    this.router.navigateByUrl('legal-entity-setup');
  }

  isCurrentRoute(path: string): boolean {
    return this.router.url.split('?')[0] === path;
  }

  /** Pre-legal-entity landing menu (To Do / Admin Dashboard and pages navigated from them). */
  get isLandingMenuContext(): boolean {
    const url = this.router.url.split('?')[0];
    return url === '/todo' || url === '/admin-dashboard' || this.sharedService.isFromTODO;
  }

  routeToPaymentRuns() {
    this.router.navigateByUrl(RouteURL.PAYMENT_RUNS);
  }

  routeToProductSolution() {
    this.router.navigateByUrl(RouteURL.PRODUCT_SOLUTIONS);
  }

  routeToBroadcastNotification() {
    this.router.navigateByUrl(RouteURL.BROADCAST_NOTIFICATION);
  }

  routeToBroadcast() {
    this.router.navigateByUrl(RouteURL.BROADCAST);
  }

  routeToExcludeDmaAccounts() {
    this.router.navigateByUrl(RouteURL.EXCLUDE_DMA_ACCOUNTS);
  }

  routeToWSPayrollUpload() {
    this.router.navigateByUrl(RouteURL.WS_PAYROLL_UPLOAD);
  }

  routeToViewEmployees() {
    this.router.navigateByUrl(RouteURL.MANAGE_EMPLOYEES);
  }

  routeToManageProducts() {
    this.router.navigateByUrl(RouteURL.MANAGE_PRODUCTS);
  }

  routeToManageUsers() {
    this.router.navigateByUrl(RouteURL.MANAGE_USERS);
  }

  routeToRoles() {
    this.router.navigate(['/roles']);
  }

  routeToAdminDashboard() {
    this.router.navigateByUrl(RouteURL.ADMIN_DASHBOARD);
  }

  /** Admin Dashboard with the Employer filter pre-set to the currently selected legal entity. */
  routeToEntityAdminDashboard() {
    this.router.navigateByUrl(RouteURL.ENTITY_ADMIN_DASHBOARD);
  }

  routeToAsqDashboard() {
    this.router.navigateByUrl(RouteURL.ASQ_DASHBOARD);
  }

  routeToUserAnalytics() {
    this.router.navigateByUrl('legal-entities/user-analytics');
  }

  routeToEntityDashboard() {
    this.router.navigateByUrl(RouteURL.LEGAL_ENTITY_DASHBOARD);
  }

  routeToLegalEntityOverview() {
    this.router.navigateByUrl(RouteURL.LEGAL_ENTITY_OVERVIEW);
  }

  subMenuEmpty() {
    this.items = [];
  }

  logout() {
    const token = sessionStorage.getItem('token');
    const req: ILogoutRequest = {
      token,
      uniqueDeviceId: '00000000-0000-0000-0000-000000000000'
    };
    this.store.dispatch(logout.loadLogoutRequest({ request: req }));
  }

  checkLegalEntityStoreState() {
    if (this.checkForRefresh === undefined) {
      this.store.dispatch(legalEntityActions.clearLegalEntitiesList());
      this.router.navigateByUrl(RouteURL.ADMIN_DASHBOARD);
    }
  }

  checkIfRegulationVerified() {
    this.subscription.add(
      this.store.select(fromToDoSelectors.selectRegulationVerified).subscribe(rv => {
        if (rv !== undefined) {
          this.isRegulationVerified = rv.regulationVerified;
          this.isPaymentMethodAdded = rv.paymentMethodAdded;
          this.isProductChosen = rv.productsChosen;
          this.isStatusVerified = rv.regulationVerified && rv.regulationApproved && rv.paymentMethodAdded && rv.productsChosen;
          this.isShowUserOnboardPage = rv.showUserOnboardPage;
          this.isDisableManageUsersPage = !rv.productsChosen;
          this.isShowUserAnalyticsPage = rv.showUserAnalyticsPage;
          this.sharedService.isLegalEntityTypeBusiness = rv.legalEntityTypeId
            ? this.sharedService.legalEntityTypeBusinessId == rv.legalEntityTypeId.toLowerCase()
            : false;
          this.cdr.markForCheck();
        }
      })
    );
  }
}
